import _ from 'lodash';
import { Record as record, List } from 'immutable';

import { construct, resolve } from './LinkMapper';

// An Object.assign which can handle JS setters/getters
function copyProperties(target, source) {
    const props = Object.getOwnPropertyNames(source);
    props.forEach((prop) => {
        const descriptor = Object.getOwnPropertyDescriptor(source, prop);
        Object.defineProperty(target, prop, descriptor);
    });
}

const PaginationHelper = {
    goTo (page) {
        const { pages } = this;
        if (pages) {
            return this.set('page', _.clamp(page, 1, pages));
        } else {
            return this.set('page', 1);
        }
    },

    get next () { return this.goTo(this.page + 1); },

    get previous () { return this.goTo(this.page - 1); },

    get end () { return this.goTo(this.pages); },

    get beginning () { return this.goTo(1); }
};

const defaults = {
    'perPage': 5,
    'page': 1,
    'data': new List()
};

export default class Pager extends record(defaults) {

    get pages () { return Math.ceil(this.data.size / this.perPage); }

    get pageData () {
        const start = (this.page - 1) * this.perPage;
        const end = start + this.perPage;
        return this.data.slice(start, end);
    }
}

export class APIPager extends record(_.zipObject(['limit', 'page', 'totalCount', 'totalPages'])) {

    get pages () { return this.totalPages || 0; }

    static fromJSON (json = {}) {
        if ('total' in json) {
            json = {
                ...json,
                totalCount: json.total,
                totalPages: Math.ceil(json.total / json.limit)
            };
        }
        return construct(APIPager, json, {
            limit: resolve.with(Number),
            page: resolve.with(Number),
            totalCount: resolve.with(Number),
            totalPages: resolve.with(Number)
        });
    }

}

copyProperties(Pager.prototype, PaginationHelper);
copyProperties(APIPager.prototype, PaginationHelper);



// WEBPACK FOOTER //
// ./src/helpers/Pager.js